/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Contact_DiscordInputs */



/**
* | output |
* | --- |
* | "Discord" |
*
* @param {Profile_Contact_DiscordInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_contact_discord = /** @type {((inputs?: Profile_Contact_DiscordInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Contact_DiscordInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Discord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Discord")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Discord")
	if (locale === "it") return /** @type {LocalizedString} */ ("Discord")
	return /** @type {LocalizedString} */ ("Discord")
});